import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import ActionButton from '../../../actionButton';
import TextBoxWithTooltip from '../../../textBoxWithTooltip';
import { ACTION_BUTTON_TYPES } from '../../../actionButton/config';

const useStyles = makeStyles(
  ({ palette: { primary }, spacing, breakpoints }) => ({
    root: {
      cursor: 'pointer',
      display: 'grid',
      alignItems: 'center',
      gridTemplateColumns:
        'minmax(80px, 80px) minmax(132px, 1fr) minmax(90px, 1fr) minmax(90px, 1fr) minmax(160px, 190px) minmax(60px, 80px)',
      boxSizing: 'border-box',
      borderBottom: `1px solid ${primary.bluish7}`,
      transition: 'background-color .3s ease',
      '&:hover': {
        backgroundColor: primary.bluish9,
      },
      '&:last-of-type': {
        borderBottom: 'none',
      },
    },
    item: {
      boxSizing: 'border-box',
      padding: spacing(4, 2),

      [breakpoints.up('xLg')]: {
        padding: spacing(4),
      },
    },
    link: {
      textDecoration: 'none',
    },
    surveyTitleWrapper: {
      minWidth: 0,
    },
    dragItemWrapper: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
      padding: spacing(4, 4, 4, 2),
      [breakpoints.up('xLg')]: {
        padding: spacing(4, 4, 4, 2),
      },
    },
    actions: {
      boxSizing: 'border-box',
      cursor: 'default',
      padding: spacing(3, 1),

      [breakpoints.up('xLg')]: {
        padding: spacing(3.5, 3),
      },
    },
    dragButton: {
      position: 'relative',
      width: 22,
      height: 22,
      flexShrink: 0,
      marginRight: spacing(1.5),
      zIndex: 11,
      '& button': {
        width: 22,
        height: 22,
      },
    },
    dragIcon: {
      width: 8,
      height: 14,
    },
    dragTooltipLabel: {
      fontFamily: 'ProximaNova-Regular',
    },
  })
);

const Survey = ({
  translations,
  survey,
  dragRef = () => {},
  dragProps = null,
  isSurveyAccessible,
}) => {
  const classes = useStyles();
  const { title, type, sentAt, expireAt, status, actions, settingsUrl } =
    survey;

  const handleActionsClick = e => e.stopPropagation();

  return (
    <div
      ref={dragRef}
      className={classes.root}
      {...(dragProps ? { ...dragProps.draggableProps } : {})}
    >
      <div className={classNames(classes.item, classes.dragItemWrapper)}>
        <ActionButton
          className={classes.dragButton}
          iconClass={classes.dragIcon}
          tooltipLabelClass={classes.dragTooltipLabel}
          type={ACTION_BUTTON_TYPES.DRAG}
          tooltipText={translations.surveyDragTooltip}
          {...(dragProps ? { ...dragProps.dragHandleProps } : {})}
        />
        {isSurveyAccessible ? (
          <Link className={classes.link} to={settingsUrl}>
            <div>{type}</div>
          </Link>
        ) : (
          <div>{type}</div>
        )}
      </div>
      {isSurveyAccessible ? (
        <Link className={classes.link} to={settingsUrl}>
          <div className={classNames(classes.item, classes.surveyTitleWrapper)}>
            {title}
          </div>
        </Link>
      ) : (
        <div className={classNames(classes.item, classes.surveyTitleWrapper)}>
          {title}
        </div>
      )}
      {isSurveyAccessible ? (
        <Link className={classes.link} to={settingsUrl}>
          <TextBoxWithTooltip className={classes.item} text={sentAt || '-'} />
        </Link>
      ) : (
        <TextBoxWithTooltip className={classes.item} text={sentAt || '-'} />
      )}
      {isSurveyAccessible ? (
        <Link className={classes.link} to={settingsUrl}>
          <TextBoxWithTooltip className={classes.item} text={expireAt || '-'} />
        </Link>
      ) : (
        <TextBoxWithTooltip className={classes.item} text={expireAt || '-'} />
      )}
      {isSurveyAccessible ? (
        <Link className={classes.link} to={settingsUrl}>
          <div>{status}</div>
        </Link>
      ) : (
        <div>{status}</div>
      )}
      <div className={classes.actions} onClick={handleActionsClick}>
        {actions}
      </div>
    </div>
  );
};

Survey.propTypes = {
  translations: PropTypes.object.isRequired,
  survey: PropTypes.object.isRequired,
  isSurveyAccessible: PropTypes.bool.isRequired,
  dragProps: PropTypes.object,
  dragRef: PropTypes.func,
};

export default Survey;
